import { SHELL_VIDEO_CALL_URL } from '../../core/shell/shell-routes.constant';

export const ERROR_STATE_TEXTS = {
  helpTitle: '¿Necesitas ayuda?',
  helpCallStart: 'Llámanos al ',
  helpPhone: '600 6600 900',
  helpWhatsappStart: ', escríbenos al WhatsApp ',
  helpWhatsapp: '+569 3639 1222',
  helpVideoStart: ' o agenda una ',
  helpVideo: 'Video Atención.',
  retryButton: 'Reintentar',
  homeButton: 'Ir al inicio',
};

export const MAX_RETRY_ATTEMPTS = 3;

export const ERROR_STATE_CONTACT = {
  phone: 'tel:6006600900',
  whatsapp: 'https://wa.me/56936391222',
  videoCall: SHELL_VIDEO_CALL_URL,
};
